
























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import User from "@/models/security/user.model";
@Component
export default class UserBase extends BaseVue {
  protected id: number|null = null;
  protected loading = false;
  protected title = {};
  protected repository!: BaseRepository<User>;

  protected model: User | any = null;

  created() {
     this.loadAll();
  }
  loadAll(){
       this.id = Number.parseInt(this.$route.params.usuarioId);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<User>("User");
      this.getData();
    }
  }
  @Watch("$route.params", {deep: true})
  onParamsChange(){
     this.loadAll();
  }

  get nombre() {
    return this.hasParent && this.model ? this.model.fullName : "---";
  }
  gotToList() {
    this.$router.push("/users");
  }
  protected async getData() {
    try {
      this.loading = true;
      if(this.id)
        this.model = await this.repository.getById(this.id);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  get hasParent() {
    return !!this.$route.params.usuarioId;
  }
}
